import { AccessGuids, ConfigSystemParams } from 'src/app/core/consts';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { eTravelRiskDataProvider } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';

@Component({
  selector   : 'app-riskline-attribution',
  templateUrl: './riskline-attribution.component.html',
  styleUrls  : ['./riskline-attribution.component.scss']
})
export class RisklineAttributionComponent {

  @Input() public alignEnd             : boolean=false;
  @Input() public compact              : boolean=false;
  @Input() public dataSourceID         : number | null=null;
  @Input() public hasRisklineEquivalent: boolean=false;
  @Input() public hideCredit           : boolean=false;
  @Input() public hideDisclaimer       : boolean=false;

  @Output() public sourceChanged: EventEmitter<eTravelRiskDataProvider>=new EventEmitter<eTravelRiskDataProvider>();

  private static nextInstanceId: number=0;

  public readonly eTravelRiskDataProvider: typeof eTravelRiskDataProvider=eTravelRiskDataProvider;
  public readonly instanceId             : number=++RisklineAttributionComponent.nextInstanceId;

  constructor(
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService
  ) { }

  //#region Public getters

  public get creditText(): string {
    try {
      if (this.showSourceToggle)
        return 'Powered by';

      return this.dataSourceID===eTravelRiskDataProvider.SureSIM
        ? 'Powered by SureSIM'
        : 'Powered by Riskline';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'Powered by Riskline';
    }
  }

  public get showPoweredBy(): boolean {
    try {
      if (this.hideCredit)
        return false;

      return this.configSystemService.getValueAsBoolean(ConfigSystemParams.RisklineShowPoweredBy, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  public get showSafetyDisclaimer(): boolean {
    try {
      if (this.hideDisclaimer)
        return false;

      return this.configSystemService.getValueAsBoolean(ConfigSystemParams.RisklineShowSafetyDisclaimer, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  public get showSourceToggle(): boolean {
    try {
      if (!this.hasRisklineEquivalent)
        return false;

      return this.componentAccessUserService.hasAccessGuid(AccessGuids.DashboardTravelRiskToggleDataSource, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Public methods

  public selectSource(source: eTravelRiskDataProvider): void {
    try {
      if (this.dataSourceID === source)
        return;

      this.sourceChanged.emit(source);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
